import { INTERACTIVE_CHIPS, VIDEO_CHIPS, type Chip } from '@/lib/frontDoor/chips';

const chipClass =
  'inline-flex h-9 items-center gap-2 rounded-full bg-b-raised px-4 text-b-control text-b-t1 transition-colors hover:bg-b-elevated aria-pressed:bg-b-ink aria-pressed:text-b-on-ink';

/** Direction B (beta only): the front door's ideas under the home box, video ideas first, then a labelled row of interactive ones. Picking one fills the box with its words. */
export function HomeIdeasB({ words, onPick }: { words: string; onPick: (chip: Chip) => void }) {
  const idea = (chip: Chip) => (
    <button key={chip.id} type="button" aria-pressed={words === chip.prompt} onClick={() => onPick(chip)} className={chipClass}>
      {chip.kind === 'interactive' && <span data-stop aria-hidden="true" className="h-[7px] w-[7px] shrink-0 rotate-45 bg-current" />}
      {chip.label}
    </button>
  );
  return (
    <div className="mt-4 flex flex-col items-center gap-3">
      <div role="group" aria-label="Start from an idea" className="flex flex-wrap justify-center gap-2">
        {VIDEO_CHIPS.map(idea)}
      </div>
      <div role="group" aria-label="Start an interactive video" className="flex flex-wrap items-center justify-center gap-2">
        <span aria-hidden="true" className="w-full text-center text-b-micro uppercase tracking-[0.08em] text-b-t3">Interactive</span>
        {INTERACTIVE_CHIPS.map(idea)}
      </div>
    </div>
  );
}
